import { toast } from "react-toastify";

/** Gen 2 evidence and library types, plus .jpeg and .xls. */
export const ALLOWED_UPLOAD_EXTENSIONS = [
  ".pdf",
  ".doc",
  ".docx",
  ".xls",
  ".xlsx",
  ".ppt",
  ".pptx",
  ".pages",
  ".odt",
  ".jpg",
  ".jpeg",
  ".png",
  ".mp3",
  ".mp4",
  ".mov",
  ".msg",
  ".eml",
  ".zip",
] as const;

const allowedExtensionSet = new Set<string>(ALLOWED_UPLOAD_EXTENSIONS);

export const ALLOWED_UPLOAD_ACCEPT = ALLOWED_UPLOAD_EXTENSIONS.join(",");

export const ALLOWED_UPLOAD_LABEL =
  "PDF, Word, Excel, PowerPoint, Pages, ODT, JPG, PNG, MP3, MP4, MOV, Outlook email (MSG, EML) or ZIP";

const extensionOf = (fileName: string): string => {
  const dot = fileName.lastIndexOf(".");
  if (dot <= 0) {
    return "";
  }
  return fileName.slice(dot).toLowerCase();
};

export function splitAllowedFiles(files: FileList | readonly File[]): {
  allowed: File[];
  rejected: File[];
} {
  const allowed: File[] = [];
  const rejected: File[] = [];
  for (const file of Array.from(files)) {
    if (allowedExtensionSet.has(extensionOf(file.name))) {
      allowed.push(file);
    } else {
      rejected.push(file);
    }
  }
  return { allowed, rejected };
}

export function toFileList(files: readonly File[]): FileList {
  const transfer = new DataTransfer();
  files.forEach((file) => transfer.items.add(file));
  return transfer.files;
}

export function rejectedFilesToast(rejected: readonly File[]): void {
  if (rejected.length === 0) {
    return;
  }
  const names = rejected.map((file) => file.name).join(", ");
  const reason =
    rejected.length === 1
      ? `${names} is not an allowed file type.`
      : `${names} are not allowed file types.`;
  toast.error(`${reason} Allowed: ${ALLOWED_UPLOAD_LABEL}.`);
}
